export enum MetricsGranularity {
  MINUTE = 'minute',
  HOUR = 'hour',
  DAY = 'day',
}
